import { AuthLayout } from './components/auth/AuthLayout';
import AuthGuard from './components/guards/AuthGuard';
import { LanguageProvider } from './context/LanguageProvider';

const Providers = ({ children, isWithLanguageParam = true }) => {
    return (
        <AuthLayout>
            <AuthGuard>
                <LanguageProvider isWithLanguageParam={isWithLanguageParam}>{children}</LanguageProvider>
            </AuthGuard>
        </AuthLayout>
    );
};

export default Providers;
